import { render, staticRenderFns } from "./DashboardSlider.vue?vue&type=template&id=376b5c9e"
import script from "./DashboardSlider.vue?vue&type=script&lang=js"
export * from "./DashboardSlider.vue?vue&type=script&lang=js"
import style0 from "./DashboardSlider.vue?vue&type=style&index=0&id=376b5c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports